import script from "./LearningJourneyFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./LearningJourneyFrame.vue?vue&type=script&setup=true&lang=js"

import "./LearningJourneyFrame.vue?vue&type=style&index=0&id=fe6b94fc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe6b94fc"]])

export default __exports__